/* ── RR Size Picker — AJAX add to cart ── */
(function () {
  'use strict';

  var openPanel = null;

  /* ── Open / close panel ── */
  function openSP(productId) {
    if (openPanel) closeSP(openPanel);
    var panel = document.getElementById('rr-sp-' + productId);
    if (!panel) return;
    panel.removeAttribute('hidden');
    openPanel = panel;
  }

  function closeSP(panel) {
    if (!panel) return;
    panel.setAttribute('hidden', '');
    if (openPanel === panel) openPanel = null;
  }

  /* ── AJAX add to cart ── */
  function addToCart(btn, variantId) {
    btn.classList.add('rr-sp__size--adding');
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.classList.remove('rr-sp__size--adding');
      btn.classList.add('rr-sp__size--added');
      btn.textContent = '✓ Added';

      /* Update cart count bubble */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubbles = document.querySelectorAll('.cart-link__bubble, .cart-count-bubble, [data-cart-count]');
          bubbles.forEach(function (el) { el.textContent = cart.item_count; });
          /* Trigger Impulse cart drawer if available */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.theme && window.theme.CartDrawer) {
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          }
        });

      /* Close panel after short delay */
      setTimeout(function () {
        var panel = btn.closest('.rr-sp');
        closeSP(panel);
        /* Reset button text after close */
        setTimeout(function () {
          btn.classList.remove('rr-sp__size--added');
          btn.textContent = btn.dataset.size;
        }, 400);
      }, 900);
    })
    .catch(function () {
      btn.classList.remove('rr-sp__size--adding');
      btn.textContent = btn.dataset.size;
      alert('Could not add to cart. Please try again.');
    });
  }

  /* ── Event delegation ── */
  document.addEventListener('click', function (e) {

    /* + button click → open size picker */
    var plusBtn = e.target.closest('.rr-quick-btn');
    if (plusBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = plusBtn.closest('[data-product-id]');
      if (card) openSP(card.dataset.productId);
      return;
    }

    /* Size button click → add to cart */
    var sizeBtn = e.target.closest('.rr-sp__size');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      var variantId = sizeBtn.dataset.variantId;
      if (variantId) addToCart(sizeBtn, parseInt(variantId, 10));
      return;
    }

    /* Close button */
    var closeBtn = e.target.closest('.rr-sp__close');
    if (closeBtn) {
      closeSP(closeBtn.closest('.rr-sp'));
      return;
    }

    /* Click outside panel → close */
    if (openPanel && !openPanel.contains(e.target) && !e.target.closest('.rr-quick-btn')) {
      closeSP(openPanel);
    }
  });

  /* Escape key closes panel */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) closeSP(openPanel);
  });

})();
